<template>
  <div class="container pos-rel" style="background: #000">
    <div class="padding-10">
      <div class="pos-rel">
        <img src="/static/images/bg-bottom.png" style="width: 100%" />
      </div>
    </div>
    <div  class=" pos-abs" style="bottom:15%;left:30%;width:50%;">
    <el-row class="text-color-white">
      <el-col :span="6">
        <div class="font-size-16">下载APP</div>
        <div class="font-size-12 margin-t-20">安卓下载</div>
        <div class="font-size-12 margin-t-10">苹果下载</div>
      </el-col>

      <el-col :span="6">
        <div class="font-size-16">热门广播剧</div>
        <div class="font-size-12 margin-t-20">祸国图壁第一季</div>
        <div class="font-size-12 margin-t-10">我的老婆是校花</div>
        <div class="font-size-12 margin-t-10">系统设定的我</div>
      </el-col>
      <el-col :span="6">
        <div class="font-size-16">平台实力</div>
        <div class="font-size-12 margin-t-20">500+作者</div>
        <div class="font-size-12 margin-t-10">爆款700部</div>
        <div class="font-size-12 margin-t-10">业内顶级和后期团队</div>
        <div class="font-size-12 margin-t-10">4.5亿听众</div>
      </el-col>
      <el-col :span="6">
        <div class="font-size-16">合作CV</div>
        <div class="font-size-12 margin-t-20">夜大大</div>
        <div class="font-size-12 margin-t-10">风寒</div>
        <div class="font-size-12 margin-t-10">夏天</div>
      </el-col>
    </el-row>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "download",
  components: {},
  data() {
    return {};
  },
  methods: {},
  created() {},
  mounted() {},
};
</script>
  
<style scoped>
</style>
  


// WEBPACK FOOTER //
// src/page/homepage/components/sm/cooperation.vue